import { Link, Typography } from '@material-ui/core'
import { format } from 'date-fns'
import { isEmpty } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'

import { subscriptionTermsAndConditionsRoute } from '../../../routes/routes'
import { getSubscriptionState, SUBSCRIPTION_STATE } from '../../../util/subscriptions'

const SubscriptionMessage = ({ subscription }) => {
  const locationSubscriptionFee = useSelector(state => state?.location?.location?.subscriptionFee)

  const state = getSubscriptionState(subscription)
  const subscriptionFee = subscription?.subscriptionFee / 100 || locationSubscriptionFee
  const nextPaymentDate = subscription?.nextPaymentDate
  const hasHadPrevSub = !isEmpty(subscription?.status)
  switch (state) {
    case SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED:
      return (
        <Typography paragraph>
          Get free delivery on all orders when you subscribe for ${subscriptionFee}/month. Cancel
          anytime in your profile.{' '}
          <Link href={subscriptionTermsAndConditionsRoute.path} target="_blank">
            Terms & Conditions
          </Link>
        </Typography>
      )
    case SUBSCRIPTION_STATE.EVERGREEN_ACTIVE:
    case SUBSCRIPTION_STATE.TRIAL_ACTIVE:
      return (
        <Typography paragraph>
          Your subscription will auto renew for ${subscriptionFee} on{' '}
          {format(nextPaymentDate, 'MM/DD/YYYY')}.
        </Typography>
      )
    case SUBSCRIPTION_STATE.EVERGREEN_UNSUBSCRIBED_ACTIVE:
    case SUBSCRIPTION_STATE.TRIAL_UNSUBSCRIBED_ACTIVE:
      return (
        <Typography paragraph>
          Your cancellation request has been received. You will continue to receive your unlimited
          delivery until {format(nextPaymentDate, 'MM/DD/YYYY')}. Resubscribe below.
        </Typography>
      )
    default:
      return (
        <Typography paragraph>
          {hasHadPrevSub
            ? `Get free delivery on all orders when you subscribe for ${subscriptionFee}/month. Cancel anytime in your profile. `
            : `Get free delivery on all orders when you subscribe for ${subscriptionFee}/month. Enjoy your first month free! Cancel anytime in your profile. `}
          <Link href={subscriptionTermsAndConditionsRoute.path} target="_blank">
            Terms & Conditions
          </Link>
        </Typography>
      )
  }
}

export default SubscriptionMessage
